import { Button, Spacer } from '@spritz-finance/ui'
import { useState } from 'react'
import { CONFIRM_SMART_PAY } from '../../../../../analytics/events'
import { Row } from '../../../../../components/Layout/Row'
import { useAnalytics } from '../../../../../context/useAnalytics'
import { TokenBalance } from '../../../../../graphql/generated/graphql'
import { useAllowanceContext } from '../../directPay/allowance/AllowanceProvider'
import { AllowanceConfiguration } from '../../directPay/form/AllowanceConfiguration'
import { AllowanceInfo } from '../../directPay/form/AllowanceInfo'
import { TokenImage } from '../../directPay/TokenListItem'
import { TransactionLogs } from '../../directPay/TransactionLogs'

type SubscriptionAllowanceProps = {
    onProceed: () => void
    token: TokenBalance
}

export const SubscriptionAllowance: React.FC<SubscriptionAllowanceProps> = ({
    onProceed,
    token,
}) => {
    const { trackAnalyticsEvent } = useAnalytics()
    const { currentAllowance, approve, approvalLoading, actionLog, clearActionLog } =
        useAllowanceContext()
    const [shouldPersistApprovalButton, setShouldPersistApprovalButton] = useState(false)

    const handleTokenApproval = () => {
        setShouldPersistApprovalButton(true)
        approve()
    }

    const handleProceed = () => {
        trackAnalyticsEvent(CONFIRM_SMART_PAY)
        clearActionLog()
        onProceed()
    }

    const requiresAllowance = currentAllowance?.isZero() ?? false

    const showApprovalButton =
        (!approvalLoading && requiresAllowance) || shouldPersistApprovalButton

    return (
        <>
            {showApprovalButton && (
                <>
                    <AllowanceInfo token={token} />
                    <Spacer height={16} />
                    <Row align="center">
                        <Button.CTA
                            disabled={!requiresAllowance}
                            onClick={handleTokenApproval}
                            loading={approvalLoading}
                        >
                            {approvalLoading ? 'Approving' : `Allow Spritz to pay with your`}
                            <Spacer width={8} />
                            <TokenImage src={token?.tokenImageUrl} />
                        </Button.CTA>
                    </Row>
                    <Spacer height={16} />
                </>
            )}
            <Row align="center">
                <Button.CTA variant="gradient" onClick={handleProceed} disabled={requiresAllowance}>
                    Set up recurring payment
                </Button.CTA>
            </Row>

            {showApprovalButton && (
                <>
                    {actionLog && <Spacer height={16} />}
                    <TransactionLogs log={actionLog} />
                </>
            )}

            <AllowanceConfiguration />
        </>
    )
}
